import { render, staticRenderFns } from "./Campus.vue?vue&type=template&id=4190f1d0"
import script from "./Campus.vue?vue&type=script&lang=js"
export * from "./Campus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4190f1d0')) {
      api.createRecord('4190f1d0', component.options)
    } else {
      api.reload('4190f1d0', component.options)
    }
    module.hot.accept("./Campus.vue?vue&type=template&id=4190f1d0", function () {
      api.rerender('4190f1d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/Campus.vue"
export default component.exports